import "./perfoMain.css";
import PerfoTop from "../components/PerfoTop";
import PerfoCenter from "../components/PerfoCenter";

const PerfoMain = () => {
  return (
    <>
      <PerfoTop />
      <PerfoCenter />
    </>
  );
};

export default PerfoMain;
